export const RequestOwnership = Object.freeze({
    OWNED_REQUESTS: "OWNED_REQUESTS",
    PARTICIPATED_REQUESTS: "PARTICIPATED_REQUESTS",
    ORGANIZATION: "ORGANIZATION",
    ALL_ORGANIZATIONS: "ALL_ORGANIZATIONS",
    ALL_REQUESTS: "ALL_REQUESTS"
})